// @flow

import React from "react";

import { isEmpty } from "ramda";

import {
  type ErrosSelecao,
  type MedidaSelecionada,
  ID_TIPO_AJUSTE_PRECO_PADRAO,
  ID_FONTE_FIDC_PADRAO,
} from "../../../model";

import {
  type State,
  i18n,
  getAjustesPrecoSelecionados,
  getExibirConfiguracoesAvancadas,
  analiseValorDaMedida,
  getUsarUltimaNegociacaoMes,
} from "../../../state";

import SelecaoAjusteDePreco from "../configuracoes/ajusteDePreco/SelecaoAjusteDePreco";

export const criaFuncaoValidacaoSeriesComAjusteEFonte = (
  state: State
) => (): ?ErrosSelecao => {
  const erros: ErrosSelecao = {};
  const { translate } = i18n(state);

  if (isEmpty(getAjustesPrecoSelecionados(state)))
    erros.ajustesPrecoNaoSelecionados = translate("erro.selecioneAjuste");

  return erros;
};

export const processarSeriesComAjusteEFonte = (
  state: State,
  medidas: Array<MedidaSelecionada>
): Array<MedidaSelecionada> => {
  const ajustesPreco = getAjustesPrecoSelecionados(state) || [];
  const exibirConfiguracoesAvancadas = getExibirConfiguracoesAvancadas(state);
  const ultimaNegociacao = getUsarUltimaNegociacaoMes(state);

  return medidas.flatMap(medida =>
    ajustesPreco.map(ajuste => {
      return {
        ...medida,
        tipoAjuste: exibirConfiguracoesAvancadas
          ? ajuste
          : ID_TIPO_AJUSTE_PRECO_PADRAO,
        fonteDeDadosFIDC: ID_FONTE_FIDC_PADRAO,
        ultimaNegociacao,
        ...analiseValorDaMedida(medida, state),
      };
    })
  );
};

const SeriesComAjusteEFonte = () => {
  return (
    <>
      <SelecaoAjusteDePreco />
    </>
  );
};

export default SeriesComAjusteEFonte;
